import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

interface Props {
  component: any;
  isAuthenticated: boolean;
}

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  ...rest
}: Props & RouteProps) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/signin", state: { from: props.location } }}
        />
      )
    }
  />
);

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.tsx